import * as types from '../mutation-types'
import api from '@/api/api'

const state = {
  viewHeight: 0,
  viewWidth: 0,
  qiniuToken: ''
}

const getters = {}

const mutations = {
  [types.base.setView](state, data) {
    state.viewHeight = data.viewHeight
    state.viewWidth = data.viewWidth
  },
  [types.base.getQiniuToken](state, data) {
    state.qiniuToken = data.Token
  }
}

const actions = {
  getQiniuToken(context) {
    return new Promise((resolve, reject) => {
      api
        .base
        .getQiniuToken()
        .then(res => {
          if (res) {
            context.commit(types.base.getQiniuToken, res.data)
            resolve()
          }
        })
        .catch(err => {
          console.log('========err', err.response)
          reject(err)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/base.js